// Turns the Carat list filter into a two-handle range slider.
// The checkbox list stays in the DOM (visually hidden); the slider just ticks
// every checkbox inside the chosen range and fires one change event, so the
// theme's own filter code builds the URL and re-renders as usual.
(() => {
  const CSS = `
    .carat-slider { padding: 8px 0 4px; }
    .carat-slider__track { position: relative; height: 24px; }
    .carat-slider__track input[type=range] {
      position: absolute; inset: 0; width: 100%; margin: 0;
      background: none; pointer-events: none; -webkit-appearance: none; appearance: none;
    }
    .carat-slider__track input[type=range] { border-color: white !important; padding: 2px; }
    .carat-slider__track input[type=range]::-webkit-slider-runnable-track { height: 2px; background: currentColor; opacity: .3; }
    .carat-slider__track input[type=range]::-moz-range-track { height: 2px; background: currentColor; opacity: .3; }
    .carat-slider__track input[type=range]::-webkit-slider-thumb {
      -webkit-appearance: none; pointer-events: auto; width: 18px; height: 18px; margin-top: -8px;
      border-radius: 50%; background: currentColor; border: 0; cursor: pointer;
    }
    .carat-slider__track input[type=range]::-moz-range-thumb {
      pointer-events: auto; width: 18px; height: 18px; border-radius: 50%; background: currentColor; border: 0; cursor: pointer;
    }
    .carat-slider__values { display: flex; justify-content: space-between; font-size: .875em; margin-top: 6px; }
  `;

  // Replace the per-value carat chips with a single "min - max" pill; X resets the slider.
  function rangePill() {
    // The filter renders per scope (top bar, sidebar, drawer); prefer the visible slider.
    const sliders = [...document.querySelectorAll('.carat-slider')];
    const wrap = sliders.find((w) => w.offsetParent) || sliders[0];
    if (!wrap) return;
    document.querySelectorAll('[data-active-filters]:not([data-range-pill])').forEach((bar) => {
      const chips = [...bar.querySelectorAll('[data-name="filter.p.m.jewellery.carat"]')];
      bar.dataset.rangePill = 'done';
      if (!chips.length) return;
      const nums = chips.map((c) => parseFloat(c.dataset.value)).filter((n) => !isNaN(n));
      chips.forEach((c) => (c.style.display = 'none'));
      const pill = document.createElement('button');
      pill.type = 'button';
      pill.className = chips[0].className;
      pill.innerHTML = `${Math.min(...nums)} - ${Math.max(...nums)} ct${chips[0].querySelector('svg')?.outerHTML || ' ×'}`;
      pill.setAttribute('aria-label', 'Clear carat range');
      pill.addEventListener('click', () => wrap._reset());
      chips[0].before(pill);
    });
  }

  function build(list) {
    list.dataset.caratSlider = 'done';

    const items = [...list.querySelectorAll('input[type=checkbox]')]
      .map((input) => ({ input, n: parseFloat(input.value) }))
      .filter((i) => !isNaN(i.n))
      .sort((a, b) => a.n - b.n);
    if (items.length < 2) return;

    const last = items.length - 1;
    const checked = items.map((i, idx) => (i.input.checked ? idx : -1)).filter((i) => i >= 0);
    const lo0 = checked.length ? checked[0] : 0;
    const hi0 = checked.length ? checked[checked.length - 1] : last;

    const wrap = document.createElement('div');
    wrap.className = 'carat-slider';
    wrap.innerHTML = `
      <div class="carat-slider__track">
        <input type="range" min="0" max="${last}" step="1" value="${lo0}" aria-label="Minimum carat">
        <input type="range" min="0" max="${last}" step="1" value="${hi0}" aria-label="Maximum carat">
      </div>
      <div class="carat-slider__values"><span></span><span></span></div>`;
    const [min, max] = wrap.querySelectorAll('input');
    const [minOut, maxOut] = wrap.querySelectorAll('.carat-slider__values span');

    const show = () => {
      if (+min.value > +max.value) [min.value, max.value] = [max.value, min.value];
      minOut.textContent = `${items[min.value].n} ct`;
      maxOut.textContent = `${items[max.value].n} ct`;
      [min, max].forEach((r) => r.setAttribute('aria-valuetext', `${items[r.value].n} carat`));
    };

    const apply = (e) => {
      // Stop the theme from treating the range input itself as a filter input.
      e.stopPropagation();
      show();
      const lo = +min.value;
      const hi = +max.value;
      const all = lo === 0 && hi === last; // full range = no carat filter
      items.forEach((i, idx) => (i.input.checked = !all && idx >= lo && idx <= hi));
      items[0].input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    min.addEventListener('input', show);
    max.addEventListener('input', show);
    min.addEventListener('change', apply);
    max.addEventListener('change', apply);

    wrap._reset = () => {
      min.value = 0;
      max.value = last;
      apply({ stopPropagation() {} });
    };

    show();
    list.classList.add('visually-hidden');
    list.before(wrap);
  }

  function init() {
    document.querySelectorAll('ul:not([data-carat-slider])').forEach((list) => {
      if (list.querySelector('input[type=checkbox][name="filter.p.m.jewellery.carat"]')) build(list);
    });
  }

  const style = document.createElement('style');
  style.textContent = CSS;
  document.head.append(style);

  const refresh = () => { init(); rangePill(); };
  refresh();
  // Filters are re-rendered via AJAX; rebuild sliders for the fresh markup.
  new MutationObserver(refresh).observe(document.body, { childList: true, subtree: true });
})();
